module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/aside_logout-921d79312e6e28be302b8721f28aa5f2.svg";